import {z as zod} from "zod";

export type OttopilotOtpWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotOtpWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotOtpWorkspaceCapabilityConfiguration> = zod.strictObject({});
